import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

console.log('---- ', baseUrl)

export const authApiService = {
    GetRolesTokenForUser
}

function GetRolesTokenForUser() {
    return axios.get(baseUrl + '/api/admin/v1/auth/getrolestoken')
}